import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { RouterProvider } from './lib/router'
import { startScreen } from './lib/contract'
import { bridge } from './lib/bridge'
import { installMockIfServerIsDown } from './lib/mock'
import './styles/app.css'
// Must load after app.css: the generated breakpoint rules override base rules
// of equal specificity, so source order decides which one wins.
import './generated/responsive.css'

bridge.start()

// Decide once, before first paint, whether the Server surface is answering.
// In a production build this resolves immediately and does nothing.
void installMockIfServerIsDown().finally(() => {
  const root = document.getElementById('root')
  if (!root) throw new Error('#root is missing from index.html')

  createRoot(root).render(
    <StrictMode>
      <RouterProvider fallback={startScreen}>
        <App />
      </RouterProvider>
    </StrictMode>,
  )
})
